import Link from "next/link";
import getConfig from "next/config";
import Stars from "@components/Ratings/Stars";

const {
  publicRuntimeConfig: {
    settings: { websiteName },
  },
} = getConfig();

const isBricoStore = websiteName === "bricostore";

const ProductPageHeaderRatings = ({
  onClick,
  reviewsCount,
  ratingSummary,
  productUrl,
}) => (
  <div className="flex items-center sm:w-auto truncate">
    {/* Brico: single star hugs the score; the anchor's ml-[4px] is the only gap. */}
    <div className={isBricoStore ? "" : "mr-1"}>
      <Stars
        percentage={
          ratingSummary &&
          reviewsCount &&
          parseFloat((((ratingSummary / reviewsCount) * 100) / 5).toFixed(0))
        }
        width="86px"
      />
    </div>

    {Boolean(ratingSummary) && Boolean(reviewsCount) && (
      <Link href={`${productUrl}#reviews`}>
        <a
          className="ml-[4px] leading-none text-sm truncate cursor-pointer inline-flex gap-[2px]"
          onClick={onClick}
        >
          {/* Brico brand guide: score shown as "nota/5" with a single decimal. */}
          <span>
            {parseFloat(ratingSummary / reviewsCount).toFixed(
              isBricoStore ? 1 : 2
            )}
            {isBricoStore && "/5"}
          </span>

          <span className="text-[#737373]">
            ({reviewsCount} {reviewsCount === 1 ? "recenzie" : "recenzii"})
          </span>
        </a>
      </Link>
    )}
  </div>
);

export default ProductPageHeaderRatings;
